import { Tag } from 'antd';
import { useEffect } from 'react';
import ApiCall from 'apps/nhsv/apiCalls/nhsv-webhooks';
import InfoCard from 'common/ui/info-card';
import { useFetchApiList } from 'hooks/api';
import { formatDateTime } from 'utils/formatDate';

const RetryPolicyInfo = ({ policy }) => {
  if (!policy) return <span>-</span>;
  return (
    <span>
      {policy.max_bursts} bursts × {policy.attempts_per_burst} attempts,{' '}
      {policy.cooldown_minutes} min cooldown
    </span>
  );
};

const ItemDetail = ({ item }) => {
  const {
    id,
    event_id,
    active,
    target_url,
    secret_key,
    secret_key_matches,
    timeout_ms,
    retry_policy,
    partner_id,
    created_at,
    updated_at,
  } = item || {};

  const { data: events, load: loadEvents } = useFetchApiList(ApiCall.events, {
    resourceName: 'data',
  });

  useEffect(() => {
    loadEvents({});
  }, []);

  const event = (events || []).find((ev: any) => ev.id === event_id);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <InfoCard label="Config ID" value={id ?? '-'} />
      <InfoCard
        label="Event"
        value={
          event
            ? `${event.event_code} (#${event_id})`
            : event_id ?? '-'
        }
      />
      <InfoCard
        label="Status"
        value={
          active ? (
            <Tag color="green">Active</Tag>
          ) : (
            <Tag color="default">Inactive</Tag>
          )
        }
      />
      <InfoCard
        label="Target URL"
        value={
          <span className="font-mono text-xs break-all">
            {target_url || '-'}
          </span>
        }
        className="md:col-span-2"
      />
      <InfoCard label="Partner ID" value={partner_id ?? '-'} />
      <InfoCard
        label="Secret Key"
        value={
          !secret_key ? (
            <Tag color="red">Not set</Tag>
          ) : secret_key_matches ? (
            <Tag color="green">Matches server</Tag>
          ) : (
            <Tag color="red">Mismatch: save this config to re-register</Tag>
          )
        }
      />
      <InfoCard label="Timeout (ms)" value={timeout_ms ?? '-'} />
      <InfoCard
        label="Retry Policy"
        value={<RetryPolicyInfo policy={retry_policy} />}
      />
      <InfoCard label="Created At" value={formatDateTime(created_at)} />
      <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
    </div>
  );
};

export default ItemDetail;
